import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M0 19.625C0 20.3844 0.615608 21 1.375 21H22.625C23.3844 21 24 20.3844 24 19.625C24 18.8656 23.3844 18.25 22.625 18.25H1.375C0.615609 18.25 0 18.8656 0 19.625ZM0 12.75C0 13.5094 0.615608 14.125 1.375 14.125H22.625C23.3844 14.125 24 13.5094 24 12.75C24 11.9906 23.3844 11.375 22.625 11.375H1.375C0.615609 11.375 0 11.9906 0 12.75ZM1.375 4.5C0.615609 4.5 0 5.11561 0 5.875C0 6.63439 0.615608 7.25 1.375 7.25H22.625C23.3844 7.25 24 6.63439 24 5.875C24 5.11561 23.3844 4.5 22.625 4.5H1.375Z' />
        </SvgIcon>
    );
});
